import React from 'react';
import { Search, X } from 'lucide-react';
import { slug } from './donnees';

const Pastille = ({ actif, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${actif ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 bg-white text-slate-700 hover:border-slate-400'}`}>
    {children}
  </button>
);

const Groupe = ({ titre, valeurs, actifs, onChange, id }) => (
  <div className="space-y-1.5">
    <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">{titre}</p>
    <div className="flex flex-wrap gap-1.5">
      <Pastille actif={!actifs.length} onClick={() => onChange([])} testid={`stats-${id}-tous`}>Tous</Pastille>
      {valeurs.map((v) => (
        <Pastille key={v} actif={actifs.includes(v)} testid={`stats-${id}-${slug(v)}`}
          onClick={() => onChange(actifs.includes(v) ? actifs.filter((x) => x !== v) : [...actifs, v])}>{v}</Pastille>
      ))}
    </div>
  </div>
);

export default function Filtres({ options, f, setF }) {
  const maj = (k) => (v) => setF({ ...f, [k]: v });
  return (
    <div className="grid gap-4 rounded-2xl border border-slate-200 bg-white p-5 lg:grid-cols-2" data-testid="stats-filtres">
      <Groupe titre="Année de couverture" id="annee" valeurs={options.annees} actifs={f.annees} onChange={maj('annees')} />
      <Groupe titre="Territoire (ventilation du CA)" id="territoire" valeurs={options.territoires} actifs={f.territoires} onChange={maj('territoires')} />
      <Groupe titre="Catégorie" id="categorie" valeurs={options.categories} actifs={f.categories} onChange={maj('categories')} />
      <div className="space-y-1.5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500">Activité</p>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input value={f.recherche} onChange={(e) => maj('recherche')(e.target.value)} placeholder="Nom ou code d'activité…"
            className="w-full rounded-lg border border-slate-200 py-2 pl-9 pr-8 text-sm focus:border-slate-500 focus:outline-none" data-testid="stats-recherche" />
          {f.recherche && <button type="button" onClick={() => maj('recherche')('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400" aria-label="Effacer"><X className="h-4 w-4" /></button>}
        </div>
        <div className="flex gap-1.5 pt-1">
          <Pastille actif={f.mesure === 'contrats'} onClick={() => maj('mesure')('contrats')} testid="stats-mesure-contrats">Nombre de contrats</Pastille>
          <Pastille actif={f.mesure === 'ca'} onClick={() => maj('mesure')('ca')} testid="stats-mesure-ca">CA des contrats</Pastille>
        </div>
      </div>
    </div>
  );
}
